import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-turns-config',
  templateUrl: './turns-config.component.html',
  styleUrls: ['./turns-config.component.scss']
})
export class TurnsConfigComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
